module.exports = __webpack_public_path__ + "static/img/show_wheel.32b07874.png";